import { BehaviorSubject, Observable } from 'rxjs';
import { Storage } from '@ionic/storage';
import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export function instantiateCompanyService(provider: CompanyProvider) {
	return (): Promise<any> => provider.initialize();
}

@Injectable()

export class CompanyProvider {
	constructor(private injector: Injector, private storage: Storage) { }

	private companySubject: BehaviorSubject<any>;

	private tokenSubject: BehaviorSubject<any>;

	public company: Observable<any>;

	public token: Observable<any>;

	public initialize() {
		return this.storage.ready().then(async ready => {
			this.companySubject = new BehaviorSubject<any>(await this.storage.get("company"));

			this.tokenSubject = new BehaviorSubject<any>(await this.storage.get("token"));

			if (this.currentTokenValue() !== null) {
				await this.refreshCompany().then(
					(response: { data: any }) => this.setCompany(response.data.companyInfo)
				).catch(
					() => this.tokenSubject.next(null)
				);
			}

			this.company = this.companySubject.asObservable();

			this.token = this.tokenSubject.asObservable();
		});
	}

	public refreshCompany(): Promise<object> {
		return this.injector.get(HttpClient).get(environment.clockUrl + "/api/index.php?service=company&action=getCompanyInfo&token=" + this.currentTokenValue()).toPromise();
	}

	public async setCompany(data) {
		return await this.storage.set("company", data).then(response => {
			this.companySubject.next(data);

			return response;
		});
	}

	public async setToken(data) {
		return await this.storage.set("token", data).then(response => {
			this.tokenSubject.next(data);

			return response;
		});
	}

	public currentTokenValue() {
		return this.tokenSubject.getValue();
	}

	public async logout() {
		return await this.storage.clear().then(() => {
			this.tokenSubject.next(null);

			this.companySubject.next(null);
		});
	}
}



// WEBPACK FOOTER //
// ./src/providers/company/company.ts